<template>
  <div>
    <a-card>
      <template slot="title">
        <strong v-if="action === 'create'">Pencairan Pembiayaan</strong>
        <strong v-if="action === 'update'">Form Pencairan Pembiayaan</strong>
        <a-button-group class="ml-2">
          <a-button
            size="default"
            :class="
              action === 'update'
                ? 'btn btn-outline-primary'
                : 'btn btn-outline-primary'
            "
            @click="handleSubmit"
            >Cairkan</a-button
          >
          <a-button class="btn btn-outline-danger" @click="resetForm"
            >Back</a-button
          >
        </a-button-group>
      </template>
      <div class="content">
        <div class="row pl-3 pr-3 pt-3 pb-3">
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <strong for="formData.tgl">Tanggal</strong>
            <a-input
              placeholder="Tanggal"
              v-model="formData.tgl"
              class=""
              :readOnly="true"
            ></a-input>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <strong for="formData.rekening">Rekening</strong>
            <a-input
              placeholder="Rekening"
              v-model="formData.rekening"
              class=""
              :readOnly="true"
            ></a-input>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <strong for="formData.nama">Nama</strong>
            <a-input
              placeholder="Nama"
              v-model="formData.nama"
              class=""
              :readOnly="true"
            ></a-input>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
            <strong for="formData.alamat">Alamat</strong>
            <a-input
              placeholder="Alamat"
              v-model="formData.alamat"
              class=""
              :readOnly="true"
            ></a-input>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 mt-2">
            <strong for="formData.telepon">Telepon</strong>
            <a-input
              placeholder="Telepon"
              v-model="formData.telepon"
              class=""
              :readOnly="true"
            ></a-input>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 mt-2">
            <strong for="formData.plafond">Plafond</strong>
            <a-input
              placeholder="Plafond"
              v-model="formData.plafond"
              class=""
              :readOnly="true"
            ></a-input>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 mt-2">
            <strong for="formData.administrasi">Administrasi</strong>
            <a-input
              placeholder="Administrasi"
              v-model="formData.administrasi"
              class=""
              :readOnly="true"
            ></a-input>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 mt-2">
            <strong for="formData.materai">Materai</strong>
            <a-input
              placeholder="Materai"
              v-model="formData.materai"
              class=""
              :readOnly="true"
            ></a-input>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 mt-2">
            <strong for="formData.notaris">Notaris</strong>
            <a-input
              placeholder="Notaris"
              v-model="formData.notaris"
              class=""
              :readOnly="true"
            ></a-input>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 mt-2">
            <strong for="formData.asuransi">Asuransi</strong>
            <a-input
              placeholder="Asuransi"
              v-model="formData.asuransi"
              class=""
              :readOnly="true"
            ></a-input>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 mt-2">
            <strong for="formData.provisi">Provisi</strong>
            <a-input
              placeholder="Provisi"
              v-model="formData.provisi"
              class=""
              :readOnly="true"
            ></a-input>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 mt-2">
            <strong for="formData.uangmuka">Uang Muka</strong>
            <a-input
              placeholder="Uang Muka"
              v-model="formData.uangmuka"
              class=""
              :readOnly="true"
            ></a-input>
          </div>
        </div>
      </div>
    </a-card>
    <a-modal
      v-model="carinasabahvisible"
      :dialogStyle="{ top: '10px' }"
      :footer="null"
      :width="800"
    >
      <template slot="title">
        <strong>{{ carinasabahtitle }} </strong>
        <strong style="margin: unset" v-if="selectedRekening !== ''">
          | Active Rekening: {{ selectedRekening }}</strong
        >
      </template>
      <!-- <template slot="footer">
          <a-button class="btn btn-outline-dark">Cancel</a-button>
          <a-button class="btn btn-outline-primary">Process</a-button>
        </template> -->
      <div class="row">
        <a-input
          class="ml-3"
          placeholder="Ketik Nama"
          v-model="input.nama"
          style="width: 200px"
          @keydown.enter="findData"
        ></a-input>
        <!-- <a-input
          class="ml-2"
          placeholder="Ketik Alamat"
          v-model="input.alamat"
          style="width: 200px"
          @keydown.enter="findData"
        ></a-input>
        <a-select
          style="width: 70px"
          placeholder="Kode"
          class="ml-2"
          v-model="input.cabang"
        >
          <a-select-option value="01">01</a-select-option>
        </a-select> -->
        <a-button
          v-if="selectedRekening !== ''"
          class="btn btn-outline-danger btn-sm ml-2"
          @click="clearRekening"
          >Clear Selected Rekening</a-button
        >
        <a-divider type="horizontal" style="margin: 8px 8px" />
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <strong
            v-if="
              table.tableatas.datatable.length !== null &&
              table.tableatas.datatable.length !== 0
            "
            class="text-primary"
            style="
              margin-left: 0.5rem;
              margin-top: 0.5rem;
              margin-bottom: unset !important;
            "
            >Jumlah Data: {{ table.tableatas.datatable.length }}</strong
          >
          <a-table
            :scroll="{ y: 300 }"
            :columns="table.tableatas.column"
            :dataSource="table.tableatas.datatable"
            :pagination="false"
            size="small"
            :customRow="customRow"
          >
            <!-- <template slot="actionButton" slot-scope="index, record">
              <a-button
                class="btn btn-outline-primary"
                @click="selectModalTable1(record)"
                >Pilih</a-button
              >
            </template> -->
          </a-table>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-2">
          <strong
            v-if="
              table.tablebawah.datatable.length !== null &&
              table.tablebawah.datatable.length !== 0
            "
            class="text-primary"
            style="
              margin-left: 0.5rem;
              margin-top: 0.5rem;
              margin-bottom: unset !important;
            "
            >Jumlah Data: {{ table.tablebawah.datatable.length }}</strong
          >
          <a-table
            :scroll="{ y: 200 }"
            :columns="table.tablebawah.column"
            :dataSource="table.tablebawah.datatable"
            :pagination="false"
            size="small"
            :customRow="customRowB"
          >
            <span slot="saldo" slot-scope="text">
              {{ formatCurrency(text) }}
            </span>
            <template slot="actionButton" slot-scope="index, record">
              <a-button
                class="btn btn-outline-primary"
                @click="selectModalTable2(record)"
                >Pilih</a-button
              >
            </template>
          </a-table>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
// import { Modal } from 'ant-design-vue'
import moment from 'moment'
import * as lou from '@/services/data/lou'
import { mapState } from 'vuex'
// import Cleave from 'vue-cleave-component'

export default {
  components: {
    // cleave: Cleave,
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  data() {
    this.lastFetchId = 0
    this.rekeningSearch = debounce(this.rekeningSearch, 800)
    return {
      editdata: JSON.parse(
        localStorage.getItem(
          'koperasisyariahedittransaksipembiayaanpencairandata',
        ),
      ),
      action: null,
      title: 'Register Nasabah',
      fetching: false,
      loadingMaster: false,
      maskInput: {
        nama: '',
        alamat: '',
      },
      formData: {
        rekening: '',
        tgl: moment(),
        pokok: '',
        bunga: '',
        denda: '',
        kas: '',
      },
      listKode: [],
      backuplistKode: [],
      listRekening: [],
      backuplistRekening: [],
      componentKey: 0,
      mastergolongandeposito: [],
      masterao: [],
      mastergolongankelompok: [],

      // Modal cari nasabah property
      carinasabahvisible: false,
      carinasabahtitle: 'Cari Nasabah',
      selectedRekening: '',
      input: {
        id: '',
        rekening: '',
        tgl: '',
      },
      table: {
        tableatas: {
          column: [
            {
              title: 'Kode',
              rowKey: 'kode',
              dataIndex: 'kode',
              scopedSlots: { customRender: 'kode' },
              width: 100,
            },
            {
              title: 'Nama',
              dataIndex: 'nama',
              scopedSlots: { customRender: 'nama' },
              width: 150,
            },
            // {
            //   title: 'KTP',
            //   dataIndex: 'ktp',
            //   scopedSlots: { customRender: 'ktp' },
            //   width: 100,
            // },
            {
              title: 'Alamat',
              dataIndex: 'alamat',
              scopedSlots: { customRender: 'alamat' },
              // width: 100,
            },
            // {
            //   title: '#',
            //   scopedSlots: { customRender: 'actionButton' },
            //   width: 70,
            // },
          ],
          datatable: [],
        },
        tablebawah: {
          column: [
            {
              title: 'Jenis',
              dataIndex: 'jenis',
              scopedSlots: { customRender: 'jenis' },
              // width: 100,
            },
            {
              title: 'Rekening',
              dataIndex: 'rekening',
              scopedSlots: { customRender: 'rekening' },
              // width: 100,
            },
            {
              title: 'Saldo',
              dataIndex: 'saldo',
              scopedSlots: { customRender: 'saldo' },
              // width: 100,
            },
            {
              title: '#',
              scopedSlots: { customRender: 'actionButton' },
              // width: 70,
            },
          ],
          datatable: [],
        },
      },
      loading: false,
    }
  },
  created() {
    // this.getMaster()
    // console.log('this.editdata.id', this.editdata.id)
    // if (this.editdata.id !== '') {
    this.action = 'update'
    this.title = 'Update Nasabah'
    this.getEditData()
    // } else {
    //   this.action = 'create'
    //   this.title = 'Create Nasabah'
    // }
    // console.log('this.action', this.action)
  },
  methods: {
    moment,
    // Modal Cari Nasabah Function
    clearRekening() {
      this.selectedRekening = ''
    },
    async findData() {
      // console.log('this.formData.rekening', this.formData.rekening)
      var imbuhan = ''
      imbuhan += this.input.nama !== '' ? '?q=' + this.input.nama : ''
      imbuhan +=
        this.input.alamat !== ''
          ? this.input.nama !== ''
            ? '&Alamat=' + this.input.alamat
            : '?Alamat=' + this.input.alamat
          : ''
      imbuhan += this.input.cabang !== '' ? '&cabang=' + this.input.cabang : ''
      var res = await lou.customUrlGet2(
        'transaksi/pembiayaan/pencairan/cari_nama' + imbuhan,
        false,
      )
      if (res) {
        if (res.data.length === 0) {
          lou.shownotif('Info', 'Data tidak ditemukan!', 'warning')
          this.table.tableatas.datatable = []
        } else {
          lou.shownotif(
            'Info',
            'Ditemukan ' + res.data.length + ' data yang cocok!',
            'success',
          )
          this.table.tableatas.datatable = res.data
        }
        // for (let i = 0; i < 20; i++) {
        //   const element = res.data[0]
        //   this.table.tableatas.datatable.push(element)
        // }
      }
    },
    async nasabahDetail(record) {
      if (!this.loading) {
        this.loading = true
        var res = await lou.customUrlGet2(
          'transaksi/pembiayaan/pencairan/cari_rekening?kode=' + record.kode,
          false,
        )
        if (res) {
          if (res.data.length === 0) {
            lou.shownotif('Info', 'Data tidak ditemukan!', 'warning')
            this.table.tablebawah.datatable = []
          } else {
            lou.shownotif(
              'Info',
              'Ditemukan ' + res.data.length + ' data yang cocok!',
              'success',
            )
            this.table.tablebawah.datatable = res.data
          }
          this.listKode = this.$g.clone(res.data)
          this.backuplistKode = this.$g.clone(res.data)
          this.loading = false
        }
        this.loading = false
      }
    },
    selectModalTable1(record) {
      this.selectedKodeRegister = record.kode
      this.formData.kode = record.kode
      this.maskInput.nama = record.nama
      this.maskInput.alamat = record.alamat
      this.nasabahDetail(record)
      this.carinasabahvisible = false
    },
    selectModalTable2(record) {
      // console.log('record', record)
      // this.selectedKodeRegister = record.kode
      // this.formData.kode = record.kode
      this.selectedRekening = record.rekening
      this.formData.rekening = record.rekening
      this.carinasabahvisible = false
    },
    customRow(record, index) {
      return {
        on: {
          click: (event) => {
            // console.log('record', record)
            // console.log('index', index)
            // console.log('event', event)
            this.selectedKodeRegister = record.kode
            this.formData.kode = record.kode
            this.maskInput.nama = record.nama
            this.maskInput.alamat = record.alamat
            this.nasabahDetail(record)
          },
          contextmenu: (event) => {
            event.preventDefault()
          },
        },
      }
    },
    customRowB(record, index) {
      return {
        on: {
          click: (event) => {
            // this.selectedKodeRegister = record.kode
            // this.formData.kode = record.kode
            // console.log('record', record)
            this.selectedRekening = record.rekening
            // console.log('index', index)
            // console.log('event', event)
            // console.log('this.selectedRekening', this.selectedRekening)
            this.formData.rekening = record.rekening
          },
          contextmenu: (event) => {
            event.preventDefault()
          },
        },
      }
    },
    formatCurrency(v) {
      return lou.curency(v)
    },
    // End of Modal Cari Nasabah Function

    fetchUser(value) {
      // console.log('fetching user', value)
      // var hasil = this.backupmasterKota.filter(x => x.city_name.toLowerCase().includes(nval))
      // console.log('hasil', hasil)
      if (value !== '') {
        var nval = value.toLowerCase()
        this.lastFetchId += 1
        const fetchId = this.lastFetchId
        this.masterKota = []
        this.fetching = true
        var res = []
        res = this.backupmasterKota.filter((x) =>
          x.city_name.toLowerCase().includes(nval),
        )
        if (res.length !== 0) {
          if (fetchId !== this.lastFetchId) {
            // for fetch callback order
            return false
          }
          this.masterKota = res.data
          this.componentKey += 1
          this.fetching = false
        } else {
          this.fetching = null
        }
      }
    },
    async rekeningSearch(value) {
      if (value !== '' && value.length >= 3) {
        this.fetching = true
        // this.formData.kode = this.formData.cabang + this.formData.rekode
        var response = await lou.customUrlGet2(
          'transaksi/pembiayaan/pencairan/cari_nama?q=' + value,
        )
        if (response) {
          this.listRekening = this.$g.clone(response.data)
          this.backuplistRekening = this.$g.clone(response.data)
          this.fetching = false
          this.componentKey += 1
          // console.log('this.backupmasterKota', this.backupmasterKota)
        } else {
          this.fetching = false
        }
      }
    },
    rekeningChange() {
      // console.log('this.maskInput.nama', this.maskInput.nama)
      // console.log('this.listRekening', this.listRekening)
      this.formData.kode = this.listRekening[this.maskInput.nama].kode
      this.kodeChange()
    },
    async kodeChange() {
      this.fetching = true
      // this.formData.kode = this.formData.cabang + this.formData.rekode
      var response = await lou.customUrlGet2(
        'transaksi/pembiayaan/pencairan/cari_rekening?kode=' +
          this.formData.kode,
      )
      if (response) {
        this.listKode = this.$g.clone(response.data)
        this.backuplistKode = this.$g.clone(response.data)
        this.fetching = false
        this.componentKey += 1
        // console.log('this.backupmasterKota', this.backupmasterKota)
      } else {
        this.fetching = false
      }
    },
    changeDateInput(dateMoment, dateString, arrdata) {
      this[arrdata[0]][arrdata[1]] = dateMoment
      // console.log('dateMoment', dateMoment)
      // console.log('dateString', dateString)
      // console.log('arrdata', arrdata)
    },
    async getMaster() {
      this.loadingMaster = true
      var res = await lou.customUrlGet2('general/master/golongandeposito')
      var res1 = await lou.customUrlGet2('general/master/ao')
      var res2 = await lou.customUrlGet2('general/master/golongankelompok')
      if (res) {
        this.mastergolongandeposito = this.$g.clone(res.data)
        // console.log('this.backupmasterKota', this.backupmasterKota)
      }
      if (res1) {
        this.masterao = this.$g.clone(res1.data)
      }
      if (res2) {
        this.mastergolongankelompok = this.$g.clone(res2.data)
      }
    },
    async handleSubmit() {
      // Should format date value before submit.
      var res = false
      var fd = {
        id: this.maskInput.id,
        rekening: this.maskInput.rekening,
        tgl: moment().format('YYYY-MM-DD'),
      }
      // console.log('fd', fd)
      // fd.rekening = fd.rekening === null || fd.rekening === undefined ? '' : this.formData.rekening
      // fd.tgllahir =
      //   this.formData.tgllahir !== null
      //     ? this.formData.tgllahir.format('YYYY-MM-DD')
      //     : null
      // fd.anggota = 1
      // fd.kodepos = parseInt(fd.kodepos)
      // fd.kodepos = fd.kodepos.toString()
      // if (this.action === 'update') {
      //   res = await lou.customUrlPut2('transaksi/pembiayaan/pencairan', fd, true)
      // } else {
      // delete fd.id
      // delete fd.rekening
      res = await lou.customUrlPost2(
        'transaksi/pembiayaan/pencairan',
        fd,
        true,
      )
      // }
      if (res) {
        // lou.shownotif(
        //   'Success',
        //   'Data baru Berhasil ditambahkan dengan nomor Register: ' + res.data,
        //   'success',
        // )
        // Modal.confirm({
        //   title: 'Cetak Validasi?',
        //   content: 'Simpan berhasil!, Cetak Validasi?',
        //   okText: 'Yes',
        //   okType: 'primary',
        //   cancelText: 'No',
        //   onOk: async () => {
        //     var res1 = await lou.ngetDocumentPdf(
        //       'transaksi/pembiayaan/pencairan/cetak/' + res.data.id,
        //       false,
        //       false,
        //     )
        //     if (res1) {
        //       this.resetForm()
        //       // console.log('res1', res1)
        //       // console.log("Success", res1ponse);
        //       const blob = new Blob([res1], {
        //         type: 'application/pdf',
        //       })
        //       var iframe = this._printIframe
        //       var url = URL.createObjectURL(blob)
        //       if (!this._printIframe) {
        //         iframe = this._printIframe = document.createElement('iframe')
        //         document.body.appendChild(iframe)

        //         iframe.style.display = 'none'
        //         iframe.onload = function () {
        //           setTimeout(function () {
        //             iframe.focus()
        //             iframe.contentWindow.print()
        //           }, 1)
        //         }
        //       }

        //       iframe.src = url
        //       // const link = document.createElement('a')
        //       // link.href = URL.createObjectURL(blob)
        //       // // link.target = '_blank'
        //       // // link.download = filename

        //       // link.download = ''
        //       // link.click()
        //       // // const objectUrl = URL.createObjectURL(blob)
        //       // // console.log('objectUrl', objectUrl)
        //       // // this.amodal.ArrayBuffer = objectUrl
        //       // URL.revokeObjectURL(blob)
        //       setTimeout(() => {
        //         this.componentKey += 1
        //         // this.amodalvisible = true
        //       }, 500)
        //     }
        //   },
        //   onCancel: () => {
        this.resetForm()
        //   },
        // })
      }
    },
    getEditData() {
      // var res = await lou.customUrlGet2('transaksi/pembiayaan/pencairan', { where: { id: this.editdata.id } })
      // console.log('this.editdata', this.editdata)
      this.formData = this.$g.clone(this.editdata)
      this.maskInput = this.$g.clone(this.editdata)
      // this.maskInput.cabang = this.editdata.kode.slice(0, this.editdata.kode.indexOf('.'))
      // this.maskInput.rekode = this.editdata.kode.slice(this.editdata.kode.indexOf('.') + 1, this.editdata.kode.length)
      this.formData.tgl = moment(this.editdata.tgl, 'YYYY-MM-DD').format(
        'DD-MM-YYYY',
      )
      this.formData.plafond = this.numberFormat(this.formData.plafond)
      this.formData.administrasi = this.numberFormat(
        this.formData.administrasi,
      )
      this.formData.materai = this.numberFormat(this.formData.materai)
      this.formData.notaris = this.numberFormat(this.formData.notaris)
      this.formData.asuransi = this.numberFormat(this.formData.asuransi)
      this.formData.provisi = this.numberFormat(this.formData.provisi)
      // console.log('this.formData', this.formData)
      // setTimeout(() => {
      //   this.formData.kodya = this.editdata.kodya
      //   this.kotaChange()
      // }, 100)
      // setTimeout(() => {
      //   this.formData.kecamatan = this.editdata.kecamatan
      //   this.kecamatanChange()
      // }, 300)
      // setTimeout(() => {
      //   this.formData.kelurahan = this.editdata.kelurahan
      //   this.kelurahanChange()
    },
    resetForm() {
      localStorage.removeItem(
        'koperasisyariahedittransaksipembiayaanpencairandata',
      )
      this.formData = {
        id: '',
        rekening: '',
        tgl: '',
      }
      this.$router.push('/koperasisyariah/transaksi/pembiayaan/pencairan/data')
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    numberFormat(val) {
      return lou.curency(val)
    },
  },
}
</script>

<style lang="scss" scoped></style>
